import { Chain, Environment } from '@shared/data-access/interfaces';
/** @format */
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, retry } from 'rxjs/operators';

import { Injectable } from '@angular/core';
import { SameDayDeliveryResponse } from '@pdp/data-access/interfaces';

@Injectable({
	providedIn: 'root'
})
export class SameDayDeliveryService {
	constructor(
		private environment: Environment,
		private chain: Chain,
		private http: HttpClient
	) {}

	getSameDayDeliveryApi$(zipCode: string, skus: number, retries = 1) {
		const url = this.environment.api.sdd.baseUrl;
		const requestUrl = `${url}v1/same-day-availability/zipcode/sku?zipCode=${zipCode}&skus=${skus}`;

		const httpHeaders = {
			'X-TIMEOUT': '10000',
			'Content-Type': 'application/json',
			channel: this.chain.chainIdentifierAbbr,
			'X-API-Key': this.environment.apiTokens.elastic.availability
		};

		const httpOptions = {
			headers: new HttpHeaders(httpHeaders)
		};

		return this.http.get(requestUrl, httpOptions).pipe(
			map((response: SameDayDeliveryResponse) => {
				return response;
			}),
			retry(retries)
		);
	}
}
